// extracted by mini-css-extract-plugin
export default {"root":"styles-module--root--c2d06","sampleList":"styles-module--sampleList--51fe7","boxes":"styles-module--boxes--1eefc","title":"styles-module--title--15915"};